export enum Country {
  Afghanistan = 'AF',
  Andorra = 'AD',
  Argentina = 'AR',
  Austria = 'AT',
  Belgium = 'BE',
  Brazil = 'BR',
  Canada = 'CA',
  Chile = 'CL',
  Estonia = 'EE',
  France = 'FR',
  FrenchGuiana = 'GF',
  Germany = 'DE',
  Gibraltar = 'GI',
  GreatBritain = 'GB',
  Guadeloupe = 'GP',
  Guernsey = 'GG',
  India = 'IN',
  Ireland = 'IE',
  Italy = 'IT',
  Jersey = 'JE',
  Martinique = 'MQ',
  Mayotte = 'YT',
  Mexico = 'MX',
  Netherlands = 'NL',
  Peru = 'PE',
  Reunion = 'RE',
  Romania = 'RO',
  Russia = 'RU',
  Slovenia = 'SI',
  Ukraine = 'UA',
  UnitedStates = 'US',
  Uruguay = 'UY'
}
